import React from 'react'
import PulsatingCircle from '../PulsatingCircle'
import { LaunchAlertStrip } from './index.style'

export function LaunchAlertWrapper({ children }) {
  return (
    <div
      className="alert bg-white f5 fw5 h3 flex items-center"
      style={{ minWidth: '25vw' }}
    >
      <LaunchAlertStrip />
      <PulsatingCircle size={2.5} color="#FCB500" />
      {children}
    </div>
  )
}

export function DismissIcon({ handleClick }) {
  return (
    <i
      className="fa fa-times ml-auto mr3 moon-gray pointer"
      onClick={handleClick}
    ></i>
  )
}



// WEBPACK FOOTER //
// ./src/components/LaunchAlert/components.js